import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

const FACET = `metadata.name`;

class EntityNameFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityNamePicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      name: EntityNameFilter;
    }
  >
    label="Entity Name"
    name="name"
    path={FACET}
    Filter={EntityNameFilter}
  />
);
